import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as flexBoxHelpersStyles } from '../../../assets/flexbox-helpers.scss';

export const templateLicenseMonthlySubscriptionTrialSubForm = document.createElement('template');

templateLicenseMonthlySubscriptionTrialSubForm.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexBoxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-accordion class='license-form-section mt-2' id='subscription-details-section' isOpen>
      <section class='subform-section'>
      <gz-text class='subform-section-label mt-2 mb-1' fontSize="14" id='subscription-preferences-label'></gz-text>
      <div class='subform-section-fields'>
        <gz-form-field-toggleable class='toggle-field' id='reserve-seats-form-field'>
          <div class='d-flex align-items-center'>
            <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
            <gz-text class='ml-1 hidden' fontSize='13' id='available-seats-text'></gz-text>
          </div>
          <gz-input-error></gz-input-error>
        </gz-form-field-toggleable>
      </div>
    </section>
    </gz-accordion>

    <gz-accordion class='license-form-section' id='own-use-section'>
      <section class='subform-section'>
        <section id='own-use-product-details'>
          <span class='subtitle'>
            <span id='own-use-product-details-endpoint-security-text'></span>
            <br>
            <gz-link type='underline' color='primary' id='own-use-product-details-endpoint-security-link'></gz-link>
          </span>
          <span class='subtitle'>
            <span id='own-use-product-details-bitdefender-edr-text'></span>
            <br>
            <gz-link type='underline' color='primary' id='own-use-product-details-bitdefender-edr-link'></gz-link>
          </span>
        </section>

        <gz-form-field id='own-use-product-type-form-field' class='label-mw-250' required>
          <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <section class='subform-section pl-2' id='own-use-addons-section' class='hidden'>
          <gz-title fontSize='11' fontWeight='600' class='title' id='own-use-addons-label'></gz-title>
          <span class='subtitle' id='own-use-addons-details'>
            <span id='own-use-addons-details-text'></span>
            <br>
            <gz-link type='underline' color='primary' id='own-use-addons-details-link'></gz-link>
          </span>
          <section class='d-flex products-and-service-section pl-2 mt-1'>
            <div class='subform-section-fields'>
              <gz-license-monthly-addons-form id='own-use-addons-form'></gz-license-monthly-addons-form>
            </div>
          </section>
        </section>
      </section>
    </gz-accordion>

    <gz-accordion class='license-form-section' id='reselling-section'>
      <section class='subform-section'>
        <section class='subform-section' id='reselling-product-section'>
          <p class='subtitle' id='reselling-product-type-details'></p>
          <section class='d-flex products-section'>
            <p class='subform-section-label mr-0 mt-3' id='reselling-product-type-label'></p>
            <div class='subform-section-fields mt-2'>
              <gz-form-field class='toggle-field' id='reselling-product-es-toggle-form-field'>
                <gz-toggle gz-form-input placeholder=''></gz-toggle>
              </gz-form-field>
              <gz-form-field class='toggle-field' id='reselling-product-edr-toggle-form-field'>
                <gz-toggle gz-form-input placeholder=''></gz-toggle>
              </gz-form-field>
            </div>
          </section>
        </section>

        <section class='subform-section pl-2' id='reselling-addons-section' class='hidden'>
          <gz-title fontSize='11' fontWeight='600' class='title' id='reselling-addons-label'></gz-title>
          <span class='subtitle' id='reselling-addons-details'>
            <span id='reselling-addons-details-text'></span>
            <br>
            <gz-link type='underline' color='primary' id='reselling-addons-details-link'></gz-link>
          </span>
          <section class='d-flex products-and-service-section pl-2 mt-1'>
            <div class='subform-section-fields'>
              <gz-license-monthly-addons-form id='reselling-addons-form'></gz-license-monthly-addons-form>
            </div>
          </section>
        </section>
      </section>
    </gz-accordion>
  </div>
`;
